const ALT_STOPWORDS = new Set([
  'a',
  'an',
  'the',
  'or',
  'of',
  'in',
  'on',
  'with',
  'and',
  'as',
  'at',
  'to',
  'is',
  'are',
  'for',
]);

const ALT_PHRASE_OVERRIDES: Array<[string, string]> = [
  ['runs alongside', 'side'],
  ['flies alongside', 'side'],
  ['video playing on the screen', 'side'],
  ['video call happening on the screen', 'perch'],
  ['perches on', 'perch'],
  ['bird perches', 'perch'],
  ['acoustic guitar', 'guitar'],
  ['vinyl records', 'records'],
  ['casette tapes', 'tapes'],
  ['rock and roll sign', 'horns'],
  ['drumsticks', 'sticks'],
  ['margarita with straw', 'marg'],
  ['paloma with straw', 'paloma'],
  ['burrito', 'pizza'],
  ['hot dog', 'hotdog'],
  ['burger with layered', 'burger'],
  ['tortilla chips', 'chips'],
  ['small cooler', 'cooler'],
];

export function slugifyAltShortLabel(text: string): string {
  const lower = text.toLowerCase();
  for (const [needle, label] of ALT_PHRASE_OVERRIDES) {
    if (lower.includes(needle)) return label;
  }
  const tokens = lower
    .replace(/[^a-z0-9\s-]/g, ' ')
    .split(/[\s-]+/)
    .filter(Boolean);
  const significant = tokens.filter((t) => !ALT_STOPWORDS.has(t));
  if (significant[0] === 'skeleton' && significant.length > 1) {
    return significant[1].slice(0, 12);
  }
  return (significant[0] ?? tokens[0] ?? 'alt').slice(0, 12);
}
